import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

export const usePlatform = () => {
  const [isNative, setIsNative] = useState(false);

  useEffect(() => {
    try {
      const native = Capacitor.isNativePlatform();
      setIsNative(native);
      console.log('[DownloadApp] platform check → isNative:', native);
    } catch (e) {
      console.warn('[DownloadApp] Capacitor check failed, assuming web:', e);
      setIsNative(false);
    }
  }, []);

  return { isNative, isWeb: !isNative };
};

export const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleResize = () => {
      const mobile = window.innerWidth < breakpoint;
      console.log('[DownloadApp] resize → isMobile:', mobile, 'innerWidth:', window.innerWidth);
      setIsMobile(mobile);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};
